module.exports = __webpack_public_path__ + "static/media/hero-bcg2.1b10c93f.jpg";